<template>
  <div class="console-theme console-operations-shell">
    <console-sidebar :active="active" />
    <main class="ops-main">
      <header class="ops-header"><div><p class="ops-eyebrow">{{ eyebrow }}</p><h1>{{ title }}</h1><p>{{ description }}</p></div><slot name="actions" /></header>
      <slot />
    </main>
  </div>
</template>

<script>
import ConsoleSidebar from './ConsoleSidebar.vue'
import '@/styles/console-operations.css'
export default {
  name: 'ConsoleOperationsLayout',
  components: { ConsoleSidebar },
  props: { active: String, title: String, description: String, eyebrow: { type: String, default: 'Workspace' } },
}
</script>
